import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    restrictedAccess: {
      description:
        'The link is no longer valid. Please reach out to the account holder for more information. He will have to generate a new link.',
      title: 'The link has expired',
    },
    tooManyRequests: {
      description:
        'The link you used is temporarily unavailable. We invite you to try again in a few hours or to connect to a secure private wifi. If the problem persists, you can contact the support.',
      title: 'Link temporarily unavailable',
    },
  },
  fr: {
    restrictedAccess: {
      description:
        'Le lien que vous avez utilisé n’est plus valable. Nous vous invitons à vous rapprocher du titulaire du compte pour plus d’informations afin qu’il puisse vous renvoyer un nouveau lien.',
      title: 'Le lien a expiré',
    },
    tooManyRequests: {
      description:
        'Le lien que vous avez utilisé est temporairement indisponible. Nous vons invitons à réessayer d’ici quelques heures ou de vous connecter sur un wifi privé sécurisé. Si le problème persiste, vous pouvez contacter le support.',
      title: 'Lien temporairement indisponible',
    },
  },
});
